import { render, staticRenderFns } from "./Gongsi.vue?vue&type=template&id=78fd7c6c&scoped=true&"
import script from "./Gongsi.vue?vue&type=script&lang=js&"
export * from "./Gongsi.vue?vue&type=script&lang=js&"
import style0 from "./Gongsi.vue?vue&type=style&index=0&id=78fd7c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd7c6c",
  null
  
)

export default component.exports